var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBevoTransmission48(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M32.7,24c0-0.5-0.1-1-0.1-1.5l2.9-2.7l-2.2-3.8l-3.8,1.2c-0.7-0.6-1.6-1.1-2.5-1.5L26.2,12h-4.4L21,15.8 c-0.9,0.3-1.8,0.8-2.5,1.5l-3.8-1.2l-2.2,3.8l2.9,2.7c-0.1,0.5-0.1,1-0.2,1.5c0,0.5,0.1,1,0.2,1.5l-2.9,2.7l2.2,3.8l3.8-1.2 c0.7,0.6,1.6,1.1,2.5,1.5l0.9,3.8h4.4l0.9-3.8c0.9-0.3,1.8-0.8,2.5-1.5l3.8,1.2l2.2-3.8l-2.9-2.7C32.7,25,32.7,24.5,32.7,24  M24,29.9c-3.3,0-6-2.7-6-5.9c0-3.3,2.7-5.9,6-5.9s6,2.7,6,5.9C30,27.3,27.3,29.9,24,29.9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBevoTransmission48);
export default __webpack_public_path__ + "static/media/ic_bevo_transmission_48.ca6eec8763a1c7321d4f83a0bf160adb.svg";
export { ForwardRef as ReactComponent };